import React, { useState } from "react";
import "./HeroSection.css";
import heroBg from "../../assets/images/aboutus_background.png";
import Images from "../../assets/images";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const HeroSection = ({ variant = 1 }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    message: "",
    consent: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { firstName, lastName, phone, email, message, consent } = formData;

    // Validation
    const phoneRegex = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!firstName.trim() || !lastName.trim()) {
      Swal.fire(
        "Missing Info",
        "Please enter your first and last name.",
        "warning"
      );
      return;
    }

    if (!phoneRegex.test(phone)) {
      Swal.fire(
        "Invalid Phone",
        "Please enter a 10-digit phone number.",
        "error"
      );
      return;
    }

    if (!emailRegex.test(email)) {
      Swal.fire(
        "Invalid Email",
        "Please enter a valid email address.",
        "error"
      );
      return;
    }

    if (!consent) {
      Swal.fire(
        "Consent Required",
        "Please agree to the consent checkbox.",
        "info"
      );
      return;
    }

    try {
      const response = await fetch("https://formspree.io/f/mldngqlj", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          firstName,
          lastName,
          phone,
          email,
          message,
          consent: "Yes",
        }),
      });

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Message Sent!",
          text: "Thank you for contacting us. We’ll get back to you shortly.",
        });

        setFormData({
          firstName: "",
          lastName: "",
          phone: "",
          email: "",
          message: "",
          consent: false,
        });
      } else {
        Swal.fire("Oops!", "Something went wrong. Please try again.", "error");
      }
    } catch (error) {
      console.error("Form error:", error);
      Swal.fire("Error", "Network error. Please try again later.", "error");
    }
  };

  if (variant === 3) {
    return (
      <section
        className="hero-section hero-variant-3"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-v3-top-box">
          <h2>Contact us</h2>
          <p>Have questions or need a demo? Our team is here to help.</p>
          <div className="hero-buttons">
            <Link to="/contact" className="hero-btn primary2">
              Book A Consultation ➤
            </Link>
            <a href="tel:+16476133478" className="hero-btn secondary2">
              Contact us ➤
            </a>
          </div>
        </div>

        <div className="hero-v3-bottom-box">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <input
                type="text"
                name="firstName"
                placeholder="First Name*"
                onChange={handleChange}
                value={formData.firstName}
                required
              />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name*"
                onChange={handleChange}
                value={formData.lastName}
                required
              />
            </div>
            <div className="form-row">
              <input
                type="tel"
                name="phone"
                placeholder="Phone*"
                onChange={handleChange}
                value={formData.phone}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email*"
                onChange={handleChange}
                value={formData.email}
                required
              />
            </div>
            <textarea
              name="message"
              placeholder="Message"
              rows="3"
              onChange={handleChange}
              value={formData.message}
            ></textarea>
            <div className="checkbox-row">
              <input
                type="checkbox"
                id="consent"
                name="consent"
                onChange={handleChange}
                checked={formData.consent}
                required
              />
              <label htmlFor="consent">
                By checking this box, I consent to receive transactional
                messages related to my account, orders, or services I have
                requested.
              </label>
            </div>
            <button type="submit" className="send-button">
              Send
            </button>
          </form>
        </div>
      </section>
    );
  }

  if (variant === 2) {
    return (
      <section
        className="hero-section hero-variant-2"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-content-split">
          <div className="hero-box">
            <h2>
              AI Solutions <br />
              <span className="highlight">for Personal Injury Lawyers</span>
            </h2>
            <p>
              Streamline Accident Benefits and TORT Claims with AI-powered
              automation.
            </p>
            <div className="hero-buttons">
              <Link to="/contact" className="hero-btn primary">
                Book A Consultation ➤
              </Link>
              <a href="tel:+16476133478" className="hero-btn secondary">
                Contact us ➤
              </a>
            </div>
          </div>
          <div className="hero-image-box">
            <img src={Images.home_img} alt="Lawyer at desk" />
          </div>
        </div>
      </section>
    );
  }

  if (variant === 4) {
    return (
      <section
        className="hero-section hero-variant-4"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-content-split">
          <div className="hero-box">
            <h2>
              Discover Our <br />
              <span className="highlight">AI-Powered Legal Tools</span>
            </h2>
            <p>
              From document automation to case tracking – explore how Nobel AI
              transforms your law firm operations.
            </p>
            <div className="hero-buttons">
              <Link to="/contact" className="hero-btn primary">
                Schedule Demo ➤
              </Link>
            </div>
          </div>
          {/* <div className="hero-image-box">
            <img src={Images.solutions_img} alt="AI Dashboard Visual" />
          </div> */}
        </div>
      </section>
    );
  }

  // Variant 1 (Default)
  return (
    <section
      className="hero-section"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      <div className="hero-overlay">
        <h1>About us</h1>
        <p>AI-Powered Legal Solutions for Faster, Smarter Case Management.</p>
        <Link to="/contact" className="hero-btn primary3">
          Book A Consultation ➤
        </Link>
      </div>
    </section>
  );
};

export default HeroSection;
